import { Link } from "react-router-dom";
import AnnouncementBar from "@/components/AnnouncementBar";
import Header from "@/components/Header";
import HeroEditorial from "@/components/home/HeroEditorial";
import FromOurHandsToYours from "@/components/home/FromOurHandsToYours";
import BeyondSunSandSea from "@/components/home/BeyondSunSandSea";
import ForestHeritageFeature from "@/components/home/ForestHeritageFeature";
import BeginYourJourney from "@/components/home/BeginYourJourney";
import SignatureRituals from "@/components/home/SignatureRituals";
import EcosystemWorlds from "@/components/home/EcosystemWorlds";
import AtmosphericBreak from "@/components/home/AtmosphericBreak";
import FromTheArchive from "@/components/home/FromTheArchive";
import FieldNotesGateway from "@/components/home/FieldNotesGateway";
import IslandObservation from "@/components/field-notes/IslandObservation";
import DiscoverIslandFeature from "@/components/home/DiscoverIslandFeature";
import LivingLegacyCard from "@/components/home/LivingLegacyCard";
import RootedMemoryEditorial from "@/components/home/RootedMemoryEditorial";
import RitualCommerce from "@/components/home/RitualCommerce";
import AboutOurBrands from "@/components/home/AboutOurBrands";
import PlacePresence from "@/components/home/PlacePresence";
import VisitTheShoppe from "@/components/home/VisitTheShoppe";
import ShoppeTransitionChamber from "@/components/home/ShoppeTransitionChamber";
import OurBelief from "@/components/OurBelief";
import CustomerReviews from "@/components/CustomerReviews";
import FeaturedDigitalLibrary from "@/components/FeaturedDigitalLibrary";
import LongevityTeaser from "@/components/LongevityTeaser";
import FlaurielTagline from "@/components/FlaurielTagline";
import IslandMoments from "@/components/IslandMoments";
import PreFooterConversion from "@/components/PreFooterConversion";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import perfumeBarImg from "@/assets/balm-bond-perfume-bar-display.png.asset.json";
import sugarTownLogo from "@/assets/sugar-town-organics-logo.png";

const Index = () => {
  return (
    <div className="min-h-screen">
      <AnnouncementBar />
      <Header />
      <main id="main-content">
        {/* 1 — Editorial hero */}
        <HeroEditorial />
        <FromOurHandsToYours />

        {/* 1b — Beyond Sun, Sand & Sea narrative shift */}
        <BeyondSunSandSea />

        {/* 1c — The Living Forest of St. Kitts + forest metrics */}
        <ForestHeritageFeature />


        {/* 2 — Philosophy strip */}
        <section className="py-20 md:py-24 bg-background">
          <div className="container mx-auto px-6 text-center max-w-3xl">
            <Reveal>
              <div className="flex justify-center mb-6">
                <img
                  src={sugarTownLogo}
                  alt="Sugar Town Organics logo"
                  className="h-20 md:h-28 w-auto"
                  loading="lazy"
                />
              </div>
              <p className="font-sans text-[11px] tracking-[0.42em] uppercase text-accent mb-5">
                Caribbean Botanicals · Heritage · Wellness
              </p>
              <h2 className="font-serif text-3xl md:text-[2.5rem] text-foreground leading-tight mb-6">
                A house built from rooted memory.
              </h2>
              <p className="font-serif italic text-foreground/75 text-lg md:text-xl leading-relaxed mb-8">
                “Sugar Town Organics is a Caribbean Legacy House rooted in the
                botanical wisdom, cultural memory and living traditions of
                St. Kitts &amp; Nevis. Through beauty, wellness, food and
                immersive experiences, we craft products and stories that honor
                heritage while nurturing modern wellbeing.”
              </p>
              <Link to="/our-story">
                <Button size="lg" variant="outline" className="font-sans uppercase tracking-[0.28em] text-[11px] px-8 border-foreground/30 hover:border-accent hover:text-accent">
                  Discover Our Story <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </Reveal>
          </div>
        </section>

        {/* 3 — Pathways */}
        <BeginYourJourney />

        {/* 4 — Signature Rituals */}
        <SignatureRituals />

        {/* Quiet quiz CTA — kept as gentle interlude */}
        <section className="py-16 md:py-20 bg-primary/5 border-y border-primary/10">
          <div className="container mx-auto px-6 text-center max-w-2xl">
            <Sparkles className="w-7 h-7 text-accent mx-auto mb-4" />
            <p className="font-sans text-[11px] tracking-[0.32em] uppercase text-accent mb-3">
              Personal Ritual
            </p>
            <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-3">
              Not sure where to begin?
            </h2>
            <p className="text-foreground/70 font-sans mb-6">
              Take our 60-second quiz and discover your personalised Caribbean
              wellness pathway — including rituals, products, experiences, and
              practices designed for your skin, hair, wellbeing, and rhythm.
            </p>
            <Link to="/quiz">
              <Button size="lg" className="font-sans uppercase tracking-[0.28em] text-[11px] px-8">
                <Sparkles className="w-4 h-4 mr-2" /> Take the Quiz
              </Button>
            </Link>
          </div>
        </section>

        <LongevityTeaser />

        {/* 5 — Ecosystem worlds */}
        <EcosystemWorlds />

        {/* Cinematic emotional pause */}
        <AtmosphericBreak />

        <OurBelief />

        {/* 6 — From the archive */}
        <FromTheArchive />

        {/* The Living Legacy of Liamuiga — flagship heritage collection */}
        <LivingLegacyCard />


        {/* Field Notes ecosystem */}
        <FieldNotesGateway />
        <IslandObservation tone="light" />

        {/* 7 — Discover island gateway */}
        <DiscoverIslandFeature />

        {/* Calm editorial breath before commerce */}
        <RootedMemoryEditorial />

        <FlaurielTagline />

        <AboutOurBrands />

        <section aria-labelledby="balm-bond-home-heading" className="py-12 md:py-16">
          <div className="container mx-auto px-6 max-w-5xl">
            <div className="grid md:grid-cols-2 overflow-hidden rounded-2xl border border-border bg-card shadow-sm">
              <img src={perfumeBarImg.url} alt="Balm & Bond perfume bar with gold-and-glass scent dispensers" loading="lazy" className="h-64 md:h-full w-full object-cover" />
              <div className="p-8 flex flex-col justify-center">
                <p className="text-xs uppercase tracking-widest text-accent mb-2">Balm &amp; Bond</p>
                <h2 id="balm-bond-home-heading" className="font-serif text-2xl md:text-3xl text-card-foreground mb-3">
                  Workshops &amp; Perfume Making
                </h2>
                <p className="text-muted-foreground mb-6">
                  Blend your own Caribbean scent or gather your group for a hands-on botanical workshop in St. Kitts.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button asChild>
                    <a href="https://tallivolegacyconnect.lovable.app/x/balm-bond-private" target="_blank" rel="noopener noreferrer">
                      Book an experience <ArrowRight className="ml-2 h-4 w-4" />
                    </a>
                  </Button>
                  <Button asChild variant="outline">
                    <Link to="/experiences/balm-and-bond">Learn more</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section aria-labelledby="company-links-heading" className="py-12 md:py-16 bg-secondary/40">
          <div className="container mx-auto px-6 text-center max-w-3xl">
            <h2 id="company-links-heading" className="font-serif text-2xl md:text-3xl text-foreground mb-3">
              Our Company Story
            </h2>
            <p className="text-muted-foreground mb-6">
              From a 2012 bake sale to award-winning Caribbean brands — explore who we are and how we grew.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button asChild>
                <Link to="/company-profile">
                  Company Profile <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/company-timeline">
                  Company Timeline <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </section>

        {/* 8 — Ritual commerce */}
        <RitualCommerce />

        <FeaturedDigitalLibrary />

        <CustomerReviews />

        {/* 9 — Physical place */}
        <PlacePresence />

        {/* Cinematic transition chamber — bridges storefront into interior experience */}
        <ShoppeTransitionChamber />

        {/* Cinematic Visit the Shoppe editorial */}
        <VisitTheShoppe />

        <IslandMoments />
        <PreFooterConversion />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
